import { AgentChatTextarea } from "./ai-chat-textarea";
import { AgentChatAudioRecorder } from "./ai-chat-audio-recorder";
import {
  AgentChatSendButton,
  AgentChatStartTranscribeButton,
  AgentChatCancelTranscribeButton,
  AgentChatFinishTranscribeButton,
  AgentChatAddFileButton,
} from "./ai-chat-buttons";
import { AgentChatToolbar } from "./ai-chat-toolbar";
import { AgentChatToolsMenu } from "./ai-chat-tools-menu";

export class AgentChatInputDefaults {
  static readonly TextArea = AgentChatTextarea;

  static readonly AudioRecorder = AgentChatAudioRecorder;

  static readonly SendButton = AgentChatSendButton;

  static readonly StartTranscribeButton = AgentChatStartTranscribeButton;

  static readonly CancelTranscribeButton = AgentChatCancelTranscribeButton;

  static readonly FinishTranscribeButton = AgentChatFinishTranscribeButton;

  static readonly AddFileButton = AgentChatAddFileButton;

  static readonly Toolbar = AgentChatToolbar;

  static readonly ToolsMenu = AgentChatToolsMenu;
}
